export const EMAIL_CHANGE = 'EMAIL_CHANGE';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';

export const emailChange = email => ({
  ...email,
  editing: 'email',
  saving: true,
  type: EMAIL_CHANGE,
});

export const verifyEmail = data => ({
  data,
  type: VERIFY_EMAIL,
});

export default {
  emailChange,
};
